import { Listings } from '../../../../api/api-listings';
import * as types from '../constants/action-types';
import { get } from 'lodash';

const fetchListingPricingRequest = (listingToFetch) => {
  return {
    type: types.LISTING_PRICING_FETCH_REQUEST,
    listingToFetch
  };
};

const fetchListingPricingSuccess = (data) => {
  return {
    type: types.LISTING_PRICING_FETCH_SUCCESS,
    data
  };
};

const fetchListingPricingFailure = (fetchError) => {
  return {
    type: types.LISTING_PRICING_FETCH_FAILURE,
    fetchError
  };
};

const clearListingData = () => {
  return {
    type: types.LISTING_CLEAR_STORE
  };
};

const updatePriceRequest = () => {
  return {
    type: types.PRICE_UPDATE_REQUEST,
    isPatching: true
  };
};

const updatePriceSuccess = () => {
  return {
    type: types.PRICE_UPDATE_SUCCESS,
    isPatching: false
  };
};

const updatePriceFailure = (updateError) => {
  return {
    type: types.PRICE_UPDATE_FAILURE,
    updateError,
    isPatching: false
  };
};

export const fetchListingPricing = (query) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchListingPricingRequest());
      Listings.read(`prices/${query}`, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchListingPricingSuccess(response));

          return resolve(response);
        }
        const error = (response || {}).error;
        dispatch(fetchListingPricingFailure(error));
        reject(error);
      });
    });
  };
};

export const updatePrice = (priceId, token, payload) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updatePriceRequest());
      return Listings.updateV2(`prices/${priceId}`, token, payload, (response) => {
        if (200 === response.statusCode) {
          const { statusCode, ...data } = response;
          dispatch(updatePriceSuccess(data));
          return resolve(data);
        }

        const fetchError = get(response, 'error', '');
        dispatch(updatePriceFailure(fetchError));
        return reject(fetchError);
      });
    });
  };
};

export const clearListingStore = () => {
  return dispatch => {
    dispatch(clearListingData());
  };
};
